import React, { useEffect } from "react";
import { ContactDetailsSection } from "../../components/contact";
import { FounderHeroSection } from "../../components/founder";
import contactData from "../../data/contactData.json";
import "../founder/founder.css";
import "./contact.css";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="contact-page">
      <FounderHeroSection data={contactData.hero} />
      <ContactDetailsSection data={contactData.details} />
    </main>
  );
}
